var map = {
	"./5031-statuario-maxima-cu-landscape-horizontal-book-mockup-3-mask.png": "9853",
	"./5151EmpiraWhite@2x.png": "8664",
	"./DarkLogo.png": "7802",
	"./OnlyWhiteLogo.png": "5472",
	"./arrow.png": "c5d4",
	"./arrow_left_en.png": "0cf6",
	"./arrow_left_he.png": "bf7e",
	"./arrow_right_en.png": "bd16",
	"./arrow_right_he.png": "f32d",
	"./arrow_white.png": "3ae6",
	"./bg-light.png": "eaa5",
	"./bitmap-copy.png": "62de",
	"./bitmap@2x.png": "7525",
	"./bitmap@2x_old.png": "0c35",
	"./book-covers-eng-NOT.png": "1629",
	"./book-covers-eng.png": "f572",
	"./closeBook_old.png": "842a",
	"./closeBook_rtl.png": "66b4",
	"./cover.png": "f5a3",
	"./coverLogo.png": "45af",
	"./cover_rtl.png": "f59b",
	"./dark-back-rtl.png": "0300",
	"./darkBack.png": "086e",
	"./darkBack_old.png": "7e6e",
	"./group-2.png": "c79c",
	"./group-3@3x.png": "d2a7",
	"./group-9.png": "15cd",
	"./group4@2x.png": "9701",
	"./left.png": "9207",
	"./leftArrow.png": "4d34",
	"./left_rtl.png": "c3bf",
	"./logo-rtl.png": "f12a",
	"./logo.png": "cf05",
	"./new-cover-piece-english.png": "5a18",
	"./new-cover-piece-hebrew.png": "5402",
	"./pages-depth-rotem.png": "1063",
	"./rectangle.png": "5896",
	"./resize-cover.png": "b27f",
	"./resize-symbol.png": "e25a",
	"./right.png": "5712",
	"./rightArrow.png": "0e0b",
	"./right_rtl.png": "61d4",
	"./rotateDownPart.png": "2b72",
	"./rotateDownPart_oldDark.png": "9787",
	"./rotateImage.png": "9b33",
	"./rotateImage_orange.png": "12b5",
	"./yellow_background_rtl.png": "65cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";